import AA from 'actions/dod/dodAuthorizationActions';

export function dodAuthorizationUpdateField(f) {
    return { type: AA.UPDATE_DOD_AUTHORIZATION_FIELD, payload: f };
}

export function dodAuthorizationUpdateTitle(t) {
    return { type: AA.UPDATE_DOD_AUTHORIZATION_TITLE, payload: t };
}

export function dodReviewStoreDesigneeLetterReference(f) {
    return { type: AA.STORE_DOD_AUTHORIZATION_DESIGNEE_REFERENCE, payload: f };
}
